<template lang="html">
  <transition name="slide">
    <footer class="prt-bottom-bar" v-show="visible">
      <prt-bottom-bar-element goal="/" icon="wallet" name="Overview" />
      <prt-bottom-bar-element goal="transactions" icon="transactions" name="Transactions" />
      <prt-bottom-bar-element goal="settings" icon="settings" name="Settings" />
    </footer>
  </transition>
</template>

<script>
import PrtBottomBarElement from './PrtBottomBarElement.vue';

export default {
  components: {
    PrtBottomBarElement,
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-bottom-bar
    position: fixed
    bottom: 0
    width: 100vw
    height: 56px
    background-color: white
    box-shadow: 0 -2px 4px black-12
    display: flex
    justify-content: center
    z-index: 999

    &.slide-enter-active,
    &.slide-leave-active
      transition: transform 200ms ease

    &.slide-enter,
    &.slide-leave-to
      transform: translateY(100%)
</style>
